<div class="dp-flex-justy-beetw tab-content mt-4 pb-2 text-align-center" id="nav-tabContent">
    <span class="w_20">{{data?.date.substring(0,10)}}</span>
    <span class="w_20">{{data?.hotelName}}</span>
    <span class="w_15">{{data.roomType}}</span>
    <span class="w_15">{{data.price}}</span>
    <span class="w_15">{{data.nbrFree}}</span>
    <button class="w_10">Add</button>
</div>